function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddOnFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.21 14.031v-10h2v10h-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.229 10.031H18.193v-2h10.035v2zM6.016 6.031v5.928h5.927V6.031H6.016zm-1-2a1 1 0 00-1 1v7.928a1 1 0 001 1h7.927a1 1 0 001-1V5.031a1 1 0 00-1-1H5.016zM6.016 20.072V26h5.927v-5.928H6.016zm-1-2a1 1 0 00-1 1V27a1 1 0 001 1h7.927a1 1 0 001-1v-7.928a1 1 0 00-1-1H5.016zM20.3 20.072V26h5.928v-5.928h-5.927zm-1-2a1 1 0 00-1 1V27a1 1 0 001 1h7.928a1 1 0 001-1v-7.928a1 1 0 00-1-1h-7.927z",
    fill: props.color
  }));
}

export default SvgIconAddOnFilled;